export default __webpack_public_path__ + "static/media/about12.a4c4907e.jpeg";